import { environment } from "@/enviroment";
import { Address, AddressRepository } from "../domain/Address";

const BASE_URL = `${environment.openBaas}/v1/address`;

export class HttpAddressRepository implements AddressRepository {
  // Ya no necesitas accessToken ni getAuthHeaders

  async getAddress(): Promise<Address[]> {
    const res = await fetch(`${BASE_URL}`, {
      credentials: "include", // Enviar cookies
    });

    if (!res.ok) throw new Error("Failed to fetch addresses");
    const data = await res.json();
    return data.response; // Retornar directamente el contenido de response
  }

  async getAddressById(addressId: string): Promise<Address | null> {
    const res = await fetch(`${BASE_URL}/${addressId}`, {
      credentials: "include",
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to fetch address");
    const data = await res.json();
    return data.response; // Retornar directamente el contenido de response
  }

  async createAddress(userId: string, address: Address): Promise<Address> {
    const res = await fetch(`${BASE_URL}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...address, userId }),
    });

    if (!res.ok) throw new Error("Failed to create address");
    const data = await res.json();
    return data.response; // Retornar directamente el contenido de response
  }

  async updateAddress(
    addressId: string,
    address: Address
  ): Promise<Address | null> {
    const res = await fetch(`${BASE_URL}/${addressId}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(address),
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to update address");
    const data = await res.json();
    return data.response; // Retornar directamente el contenido de response
  }

  async deleteAddress(addressId: string): Promise<void> {
    const res = await fetch(`${BASE_URL}/${addressId}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to delete address");
    // No retorna nada porque es void
  }
}
